export default class ContractInstance {
  id: string;

  code: string;

  description: string;

  startedAt: string;

  concludedAt: string;

  active: boolean;

  hasBilling: boolean;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.code = obj.code || '';
    this.active = obj.active || false;
    this.description = obj.description || '';
    this.startedAt = obj.startedAt || '';
    this.concludedAt = obj.concludedAt || '';
    this.hasBilling = obj.hasBilling || false;
  }

  public static of(obj: any): ContractInstance {
    return new ContractInstance(obj || {});
  }

  public static ofList(obj: any[]): ContractInstance[] {
    return obj.map(this.of);
  }

  get status(): string {
    return this.active ? 'ativo' : 'inativo';
  }

  get instanceText(): string {
    return `${this.code} - ${this.description}`
  }
}
